export default "__VITE_ASSET__DiGnY$Jn__"